import React from 'react';

import { ApiErrors, ParsedData, useQuery } from '@betterment/js-runtime';

import { urlBuilder } from '../../Shared/urlBuilder';
import { Customer } from '../data';

export interface CustomerResponseContext {
  customer: Customer | null;
  error: ApiErrors | null;
  loading: boolean;
  refetch: () => Promise<ParsedData<Customer>>;
}

export const CustomerContext = React.createContext<CustomerResponseContext | null>(null);

export const CustomerResponseProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { data, errors: error, loading, refetch } = useQuery<Customer>(urlBuilder.getCustomer());
  const values = React.useMemo(() => ({ customer: data, error, loading, refetch }), [data, error, loading, refetch]);
  return <CustomerContext.Provider value={values}>{children}</CustomerContext.Provider>;
};

export const useCustomerResponse = () => {
  const context = React.useContext(CustomerContext);

  if (!context) {
    throw new Error('useCustomerResponse must be used under CustomerResponseProvider');
  }

  return context;
};
